import './styles/Announcement.css';

const Announcement = ({ text, date, person, link, linkText }) => {
  const arabicExists = text.substring(0, 10).match(/[\u0600-\u06FF]/g);
  return (
    <li
      className='announcement'
      dir={arabicExists ? 'rtl' : 'ltr'}
      style={{ listStyle: 'none' }}>
      <h1>
        {text}&nbsp;
        {link && (
          <a href={link} target='_blank' rel='noreferrer'>
            {linkText}
          </a>
        )}
      </h1>
      <p>
        by {person} at {date}
      </p>
    </li>
  );
};

export default Announcement;
